import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef } from '@angular/core';
import {
    MatLegacyListModule as MatListModule,
    MatLegacySelectionListChange as MatSelectionListChange
} from '@angular/material/legacy-list';
import { FilterBase } from './filter-base';
import { NgStyle, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'nova-checkbox-filter',
    template: ` <mat-selection-list
        (selectionChange)="addOption($event)"
        [ngStyle]="filterStyle">
        @for (value of optionValues; track value; let i = $index) {
            <mat-list-option
                [value]="value"
                [selected]="selectedValues.includes(value)">
                @if (optionTemplate) {
                    <ng-container
                        [ngTemplateOutlet]="optionTemplate"
                        [ngTemplateOutletContext]="{ value: value, title: optionTitles[i] }">
                    </ng-container>
                }
                @if (!optionTemplate) {
                    <span>{{ optionTitles[i] }}</span>
                }
            </mat-list-option>
        }
    </mat-selection-list>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgStyle, MatListModule, NgTemplateOutlet]
})
export class CheckboxFilterComponent extends FilterBase implements OnInit {
    @Input() options: any = [];
    @Input() optionTemplate: TemplateRef<any>;
    @Input() filterStyle: any;
    @Input() uniqueFilterClass = '';
    optionTitles: string[] = [];
    optionValues: any[] = [];

    selectedValues: any[];

    ngOnInit() {
        if (Array.isArray(this.options)) {
            this.optionTitles = this.optionValues = this.options;
        } else {
            this.optionTitles = Object.keys(this.options);
            //TODO - change to Object.values when we upgrade to Typescript 3+ (Angular 6+)
            this.optionValues = Object.keys(this.options).map((k) => this.options[k]);
        }

        this.selectedValues = this.getLatestFilterValue() || [];
    }

    addOption(item: MatSelectionListChange) {
        const ix = this.selectedValues.indexOf(item.options[0].value);
        if (ix >= 0) {
            this.selectedValues.splice(ix, 1);
        } else {
            this.selectedValues.push(item.options[0].value);
        }

        if (this.selectedValues.length === this.optionValues.length) {
            //clear filter if all options are checked
            this.filterService.filter({ filters: [], logic: 'and' });
        } else {
            this.filterService.filter({
                filters: [
                    {
                        field: this.field,
                        operator: 'eq',
                        value: this.selectedValues
                    }
                ],
                logic: 'and'
            });
        }
    }
}
